import React, { useState } from 'react';
import ViewItems from '../../../components/ViewItems';
import Text from '../../../components/Text';
import { COLORS, fontSizes } from '../../../constants/constants';
import dynamicfunction from '../../../utils/dynamicfunction';
import ViewReverse from '../../../components/ViewReverse';
import { cn, formatNumbers } from '../../../utils/utils';
import SarSymbol from '../../../components/SarSymbol';

const CardView = ({ title, amount, isSymbol, digit = 2 }) => {
  const { TextWeight, isArabic } = dynamicfunction();

  return (
    <ViewItems
      className={cn('border border-grey shadow rounded-xl px-5 py-5 w-full', isSymbol && "items-start")}
    >
      <ViewReverse isReverse={false}>
        <Text
          text={title}
          size={fontSizes.h16}
          color={COLORS.black}
          weight={TextWeight.semiBold}
          isTruncate={false}
        />
      </ViewReverse>

      <ViewReverse className={'items-center mt-4'} isReverse={isSymbol ? true : false}>
        {isSymbol && <SarSymbol size={fontSizes.h26} color={'text-black'} />}
        <Text
          color={COLORS.black}
          text={formatNumbers(amount, digit)}
          size={fontSizes.h26}
          weight={TextWeight.medium}
        />
      </ViewReverse>
    </ViewItems>
  );
};

export default CardView;
